<app-page-header
  >Order Complete
  <ng-container subtitle
    >Thanks, the order for your replacement has been processed.</ng-container
  >
</app-page-header>

<div class="order-details">
  <app-content-module>
    <div class="table">
      <div class="table__content">
        <h2>Order details</h2>
        <ul class="list">
          <li
            class="list__item--icon-generic-appliance table__row table__row--model margin--none"
          >
            <p class="description">
              <strong> Replacement product </strong>
            </p>

            <p class="model margin--none">
              <strong>{{ data?.make }} </strong>{{ data?.model }}<br />
              {{ data?.applianceCategory }}
            </p>
          </li>

          <!-- TODO the new policy is not available post confirmation -->
          <li
            *ngIf="false"
            class="list__item--icon-plan table__row table__row--model margin--none"
          >
            <p class="description">
              <strong> New policy number </strong>
            </p>

            <p class="model margin--none">
              {{ data?.planNumber || 'Not Protected' }}
            </p>
          </li>

          <!-- TODO the installation info is not available post confirmation -->
          <li
            *ngIf="false"
            class="list__item--icon-installation table__row margin--none"
          >
            <p class="description">
              <strong> Installation </strong>
            </p>
            <p class="data margin--none">
              {{
                data?.isInstallationSelected === null
                  ? 'Data not available'
                  : data?.isInstallationSelected
                  ? 'Yes'
                  : 'Not included'
              }}
            </p>
          </li>
          <!-- TODO the disposal info is not available post confirmation -->
          <li
            *ngIf="false"
            class="list__item--icon-disposal table__row table__row--total margin--none"
          >
            <p class="description">
              <strong> Recycling </strong>
            </p>

            {{
              data?.isDisposalSelected === null
                ? 'Data not available'
                : data?.isDisposalSelected
                ? 'Yes'
                : 'Not included'
            }}
          </li>
        </ul>
      </div>
    </div>
  </app-content-module>
</div>

<div class="deliveryDetails">
  <div class="table table__content">
    <h2>Delivery details</h2>

    <ng-container *ngIf="!supplierToArrange">
      <p>
        We'll contact you on the day of the delivery to let you know that your
        replacement will soon be with you.
      </p>
      <p>
        You can now rest assured knowing that your replacement is on its way.
        <a class="link link--primary" target="_blank" [href]="faqUrl"
          >Find out more about deliveries in our FAQs</a
        >.

        <br />

        <!-- TODO needs to be resolved if customer took out new plan -->
        <ng-container *ngIf="false">
          For further peace of mind, get covered for your new appliance.
          <a
            class="link link--primary"
            target="_blank"
            href="https://www.domesticandgeneral.com/content/help-advice-section/faq/purchasing-protection"
            >Find out more about cover in our FAQs</a
          >.
        </ng-container>
      </p>
    </ng-container>

    <ng-container *ngIf="supplierToArrange">
      <p>
        You’ll be contacted by the service provider to let you know when your
        replacement will be delivered.
      </p>
      <br />
    </ng-container>

    <ul class="list">
      <li class="table__row margin--none" *ngIf="!supplierToArrange">
        <div class="extra">
          <p class="margin--none">
            <strong> Date of delivery </strong>
          </p>
        </div>
        <div class="data">
          <p class="margin--none">
            {{ data?.deliveryDate }}
          </p>
        </div>
      </li>

      <li class="table__row margin--none">
        <div class="extra">
          <p class="margin--none">
            <strong> Delivery address </strong>
          </p>
        </div>
        <div class="data address">
          <p>
            <span [dgxQmSanitise]="'block'">{{ data?.contact?.title }} </span>
            <span [dgxQmSanitise]="'block'">{{ data?.contact?.surname }} </span>
          </p>
          <p [dgxQmSanitise]="'block'">
            {{ data?.deliveryAddress?.address_line_1 }}
          </p>

          <p [dgxQmSanitise]="'block'">
            {{ data?.deliveryAddress?.address_line_2 }}
          </p>
          <p [dgxQmSanitise]="'block'">
            {{ data?.deliveryAddress?.address_line_3 }}
          </p>
          <p [dgxQmSanitise]="'block'">
            {{ data?.deliveryAddress?.address_line_4 }}
          </p>
          <p [dgxQmSanitise]="'block'">
            {{ data?.deliveryAddress?.postal_code }}
          </p>
        </div>
      </li>

      <li class="table__row margin--none">
        <div class="extra">
          <p class="margin--none">
            <strong> Delivered by </strong>
          </p>
        </div>
        <div class="data">
          <p class="margin--none">
            {{
              data?.deliveredBy === undefined
                ? 'Data not available'
                : data?.deliveredBy
            }}
          </p>
        </div>
      </li>
      <li class="table__row margin--none"></li>
    </ul>
  </div>
</div>
